/** 对客状态码，由 kcc-service ShipmentStatusMapper 从 KFC 内部状态映射而来。 */
export const SHIPMENT_STATUS_OPTIONS = [
  { value: 'PREPARING', label: 'Preparing goods' },
  { value: 'READY_FOR_DEPARTURE', label: 'Ready for departure' },
  { value: 'IN_TRANSIT', label: 'In transit' },
  { value: 'OUT_FOR_DELIVERY', label: 'Out for delivery' },
  { value: 'DELIVERED', label: 'Delivered' },
] as const;

const LABEL_MAP: Record<string, string> = Object.fromEntries(
  SHIPMENT_STATUS_OPTIONS.map((o) => [o.value, o.label])
);

export function statusLabel(code?: string | null): string {
  if (!code) return '—';
  return LABEL_MAP[code] || code;
}
